import { z } from "zod";

/**
 * `validCompletionFingerprint` (docs/plans/field-crypto-phase2.md 1.2.1): a
 * job's completion source is the bare v1 sha256 on an unmarked row and
 * `cd1:` + sha256 on a sealed one. The silo twin is
 * `isCompletionSourceFingerprint` in convex-silo/jobCompletionSource.ts.template.
 * Every captured source (call args, proofs, undo heads) accepts both forms
 * until the jobTasks narrow; other fingerprints (component, receipt, plan)
 * stay bare 64-hex.
 */
export const COMPLETION_SOURCE_FINGERPRINT_PATTERN = /^(cd1:)?[a-f0-9]{64}$/;
export const completionSourceFingerprintSchema = z.string().regex(COMPLETION_SOURCE_FINGERPRINT_PATTERN);

/**
 * The undo-verification generation: a bare sha256 on an unmarked
 * conversation, `cd1:` + a keyed HMAC (sm-cd:v1, "undoGeneration") on a
 * sealed one (plan 1.2.1 "Undo generation").
 */
export const completionUndoGenerationSchema = z.string().regex(COMPLETION_SOURCE_FINGERPRINT_PATTERN);

/**
 * A pre-seal undo, still to be applied, whose job row's 30-day alias window
 * has closed (plan 1.2.1 step 5). The silo throws it as a `ConvexError`
 * code; the undo control renders it as "can no longer be undone".
 */
export const COMPLETION_UNDO_EXPIRED_BY_ENCRYPTION = "COMPLETION_UNDO_EXPIRED_BY_ENCRYPTION";
